$mol_form_draft $mol_form
	model $mol_object2
	model_pick*? null
	changed false
	state? null $mol_form_draft_state
	state_pick*? null
	value*? null
	value_str*? \
	value_bool*? false
	value_number*? 0
	dictionary_bool*? *
	list_string*? /string
	value_changed* false
	reset? null
	done? null
	state_normalized /readonly[string,null|$mol_form_draft_state_value]
	model_push null
	buttons /$mol_view
		<= Submit
		<= Reset $mol_button_minor
			hint <= reset_title @ \Reset
			sub / <= Reset_icon $mol_icon_restore
			click? <=> reset?
